import gtags from '_static/gtags.json'
import { ACCEPTANCE_COOKIE_NAME, MINIMUM_COOKIE_NAME } from '@/constants/cookies'
import { OPENSALUD_PLATFORM_NAME } from '@/constants/platformNames'
import Vue from 'vue'
import { inProductionEnv } from '@/helpers/global.helpers'

export default {
    mounted () {
        // Load only if all cookies are enabled
        if (!!Vue.$cookies.get(ACCEPTANCE_COOKIE_NAME) && !Vue.$cookies.get(MINIMUM_COOKIE_NAME)) {
            const platform = (this.$route.meta && this.$route.meta.gtag || this.$route.meta.tagLine) ? (this.$route.meta.gtag || this.$route.meta.tagLine) : OPENSALUD_PLATFORM_NAME
            if (platform) {
                const keyName = gtags[platform] ? gtags[platform] : OPENSALUD_PLATFORM_NAME
                for (var script of keyName) {
                    let htmlScript = document.createElement('script')
                    htmlScript.setAttribute('src', script)
                    document.head.appendChild(htmlScript)
                }
            }
						// Add hotjar
						if (inProductionEnv) {
							let hjScript = document.createElement('script')
							hjScript.setAttribute('src', '/static-appopensalud/hotjar.js')
							document.head.appendChild(hjScript)
						}
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/gtag.mixin.js